// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { ClipboardService } from '../../../../services/clipboard.service';

export interface ISaveKeyDialogConfig {
  password: string;
}

@Component({
    selector: 'app-save-key-dialog',
    templateUrl: './save-key-dialog.component.html',
    styleUrls: ['./save-key-dialog.component.scss'],
    standalone: false
})
export class SaveKeyDialogComponent {
  confirmed = false;
  password = '';

  fTitle: string;
  fParA: string;
  fParB: string;
  fWarning: string;
  fCopy: string;
  fConfirm: string;
  fCancel: string;
  fClose: string;
  constructor(
    public dialogRef: MatDialogRef<SaveKeyDialogComponent>,
    private translate: TranslateService,
    private readonly clipboard: ClipboardService,
    @Inject(MAT_DIALOG_DATA) public data: ISaveKeyDialogConfig,
  ) {
    this.translate.get(['SK_TITLE', 'SK_PARA', 'SK_PARB', 'SK_WARNING', 'SK_COPY', 'SK_CONFIRM',
      'CANCEL_CAP', 'SK_CLOSE']).subscribe(vals => {
       this.fTitle = vals['SK_TITLE'];
       this.fParA = vals['SK_PARA'];
       this.fParB = vals['SK_PARB'];
       this.fWarning = vals['SK_WARNING'];
       this.fCopy = vals['SK_COPY'];
       this.fConfirm = vals['SK_CONFIRM'];
       this.fCancel = vals['CANCEL_CAP'];
       this.fClose = vals['SK_CLOSE'];
    });
    this.password = data.password;
  }

  copyPassword(): void {
    this.clipboard.copyMessage(this.password, this.translate.instant('COPIED_TO_CLIPBOARD')).then(null);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }
}
